<div class="container">
        <!-- Header Actions -->
        <div class="header-actions">
            <button mat-flat-button color="primary" class="my-btn" onclick="submitInvoice()" style="margin-left: 10px;">Submit Invoice</button>
            <button mat-flat-button color="primary" class="my-btn" onclick="createInvoice()">Create Invoice</button>
        </div>

       <!-- Invoice Content -->
      <div class="invoice-content">
        <h1 class="invoice-title">Customer Invoice</h1>

        <!-- Basic Invoice Info -->
        <div class="invoice-basic-info">
          <div>
            <label for="invoiceNumber">Invoice Number</label>
            <input
              type="text"
              id="invoiceNumber"
              name="invoiceNumber"
              placeholder="INV-2025-001"
            />
          </div>
          <div>
            <label for="invoiceDate">Invoice Date</label>
            <input type="date" id="invoiceDate" name="invoiceDate" />
          </div>
        </div>

        <!-- Customer and Billing Details -->
        <div class="invoice-header">
          <div class="customer-details">
            <h3 class="section-title">Customer Information</h3>
            <div>
              <label for="customer">Customer</label>
              <input
                type="text"
                id="customer"
                name="customer"
                placeholder="Company Name"
              />
            </div>
            <div>
              <label for="billingAddress">Billing Address</label>
              <textarea
                rows="8"
                cols="50"
                id="billingAddress"
                name="billingAddress"
                placeholder="Enter billing address"
              ></textarea>
            </div>
          </div>

          <div class="billing-details">
            <h3 class="section-title">Billing Information</h3>
            <div>
              <label for="billFrom">Requisition No.</label>
              <input
                type="text"
                id="RequisitionNo"
                name="RequisitionNo"
                placeholder="Requisition No."
              />
            </div>
            <div class="two-col-row">
              <div>
                <label for="contactPerson">Contact Person</label>
                <input
                  type="text"
                  id="contactPerson"
                  name="contactPerson"
                  placeholder="Contact Name"
                />
              </div>
              <div>
                <label for="contactNo">Contact No</label>
                <input
                  type="text"
                  id="contactNo"
                  name="contactNo"
                  placeholder="Phone Number"
                />
              </div>
            </div>
            <div>
              <label for="gstNo">GST No</label>
              <input
                type="text"
                id="gstNo"
                name="gstNo"
                placeholder="GST Registration Number"
              />
            </div>
            <div class="two-col-row">
              <div>
                <label for="terms">Terms</label>
                <input
                  type="text"
                  id="terms"
                  name="terms"
                  placeholder="Payment Terms"
                />
              </div>
              <div>
                <label for="state">State</label>
                <input
                  type="text"
                  id="state"
                  name="state"
                  placeholder="State"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Remarks -->
        <div class="remarks-section">
          <div>
            <label for="remarks">Remarks</label>
            <textarea
              id="remarks"
              name="remarks"
              placeholder="Additional notes or remarks"
            ></textarea>
          </div>
        </div>

        <!-- Training Details Table -->
        <div class="table-container">
          <table id="trainingTable">
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Requisition No</th>
                <th>Course</th>
                <th>Training Title</th>
                <th>Participants</th>
                <th>Resource Utilised Hours</th>
                <th>Per Hour Resource Cost</th>
                <th>Resource Cost</th>
                <th>Training Cost Per Trainee</th>
                <th>Total Training Cost</th>
                <th>Other Expenses</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody id="trainingTableBody">
              <tr>
                <td>1</td>
                <td class="editable-cell">
                  <input type="text" placeholder="REQ-001" value="REQ-001" />
                </td>
                <td class="editable-cell">
                  <input type="text" placeholder="Custom" value="Custom" />
                </td>
                <td class="editable-cell">
                  <input
                    type="text"
                    placeholder="Azure VMs Setup"
                    value="Azure VMs Setup"
                  />
                </td>
                <td class="editable-cell">
                  <input
                    type="number"
                    placeholder="10"
                    value="10"
                    onchange="calculateRow(1)"
                  />
                </td>
                <td class="editable-cell">
                  <input
                    type="number"
                    placeholder="85"
                    value="85"
                    onchange="calculateRow(1)"
                  />
                </td>
                <td class="editable-cell">
                  <input
                    type="number"
                    step="0.01"
                    placeholder="10"
                    value="10"
                    onchange="calculateRow(1)"
                  />
                </td>
                <td class="calculated-cell">850</td>
                <td class="editable-cell">
                  <input
                    type="number"
                    step="0.01"
                    placeholder="0"
                    value="0"
                    onchange="calculateRow(1)"
                  />
                </td>
                <td class="calculated-cell">0</td>
                <td class="editable-cell">
                  <input
                    type="number"
                    step="0.01"
                    placeholder="0"
                    value="0"
                    onchange="calculateRow(1)"
                  />
                </td>
                <td class="calculated-cell total-cell">850</td>
              </tr>
              <tr>
                <td>2</td>
                <td class="editable-cell">
                  <input type="text" placeholder="REQ-003" value="REQ-003" />
                </td>
                <td class="editable-cell">
                  <input
                    type="text"
                    placeholder="Azure fundamental"
                    value="Azure fundamental"
                  />
                </td>
                <td class="editable-cell">
                  <input
                    type="text"
                    placeholder="DevOps Training"
                    value="DevOps Training"
                  />
                </td>
                <td class="editable-cell">
                  <input
                    type="number"
                    placeholder="20"
                    value="20"
                    onchange="calculateRow(2)"
                  />
                </td>
                <td class="editable-cell">
                  <input
                    type="number"
                    placeholder="45"
                    value="45"
                    onchange="calculateRow(2)"
                  />
                </td>
                <td class="editable-cell">
                  <input
                    type="number"
                    step="0.01"
                    placeholder="10"
                    value="10"
                    onchange="calculateRow(2)"
                  />
                </td>
                <td class="calculated-cell">450</td>
                <td class="editable-cell">
                  <input
                    type="number"
                    step="0.01"
                    placeholder="25"
                    value="25"
                    onchange="calculateRow(2)"
                  />
                </td>
                <td class="calculated-cell">500</td>
                <td class="editable-cell">
                  <input
                    type="number"
                    step="0.01"
                    placeholder="0"
                    value="0"
                    onchange="calculateRow(2)"
                  />
                </td>
                <td class="calculated-cell total-cell">950</td>
              </tr>
            </tbody>
          </table>
          <button class="add-row-btn my-btn" onclick="addRow()">+ Add Row</button>
        </div>

        <!-- Totals Section -->
        <div class="totals-section">
          <table class="totals-table">
            <tr>
              <td class="label-cell">Total</td>
              <td class="amount-cell" id="subtotal">1800</td>
            </tr>
            <tr>
              <td class="label-cell">CGST (9%)</td>
              <td class="amount-cell" id="cgst">162</td>
            </tr>
            <tr>
              <td class="label-cell">SGST (9%)</td>
              <td class="amount-cell" id="sgst">162</td>
            </tr>
            <tr>
              <td class="label-cell">IGST (18%)</td>
              <td class="amount-cell" id="igst">0</td>
            </tr>
            <tr class="total-row">
              <td class="label-cell">Total Billing Amount</td>
              <td class="amount-cell" id="totalAmount">2124</td>
            </tr>
          </table>
        </div>
      </div>
    </div>